import {
  PageBlueprint,
  createFrontendPlugin,
} from '@backstage/frontend-plugin-api';
import HomeIcon from '@material-ui/icons/Home';

export const homePlugin = createFrontendPlugin({
  pluginId: 'home',
  title: 'Home',
  icon: <HomeIcon />,
  extensions: [
    PageBlueprint.make({
      params: {
        path: '/',
        title: 'Home',
        icon: <HomeIcon />,
        loader: async () =>
          import('./HomePage').then(module => <module.HomePage />),
      },
    }),
  ],
});
